import NetworkBehavior from "../lib/NetworkBehavior";
import { Time } from "../lib/Time";
import { Physics } from "../math/Physics";
import { clamp01 } from "../util";
import Color from "../util/Color";
import Player from "./Player";

export default class HealingFieldBehavior extends NetworkBehavior {
    team: "red"|"blue"|undefined;
    born = Time.time;
    size = 256;
    lifetime = 5;
    rings: number[] = [1];
    ringTimer = 1;

    get timeAlive() {return Time.time-this.born;}

    Die() {
        this.engine.RemoveGameObject(this.gameObject);
    }

    Update(): void {
        if (this.timeAlive >= this.lifetime) {
            this.Die();
        }

        if (this.ringTimer > 0) {
            this.ringTimer -= Time.deltaTime;

            if (this.ringTimer <= 0) {
                this.rings.push(1);
                this.ringTimer = 1;
            }
        }

        const players = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team === this.team
        );

        if (this.engine.clientPlayer && this.engine.clientPlayer.team === this.team && Physics.CircleCircleCollision({
            position: this.transform.position,
            radius: this.size
        }, {
            position: this.engine.clientPlayer.transform.position,
            radius: this.engine.clientPlayer.size
        }) !== false) {
            this.engine.clientPlayer.hp += 50 * Time.deltaTime;
            if (this.engine.clientPlayer.hp > this.engine.clientPlayer.maxHp) this.engine.clientPlayer.hp = this.engine.clientPlayer.maxHp;
        }

        for (let i = this.rings.length - 1; i >= 0; i--) {
            this.rings[i] += 128 * Time.deltaTime;

            if (this.rings[i] >= this.size) {
                this.rings.splice(i, 1);
            }
        }
    }

    Draw(): void {
        const color = this.engine.clientPlayer?.team === this.team ? Color.fromHex('#55ff55') :Color.fromHex('#ff5555');
        this.ctx.strokeStyle = color.toHexWithAlpha(0.1);
        this.ctx.lineWidth = 1;
        this.engine.StrokeCircle(this.transform.position, this.size);

        for (const ring of this.rings) {
            const a = clamp01(1 - ring/this.size);
            this.ctx.strokeStyle = color.toHexWithAlpha(a);
            this.engine.StrokeCircle(this.transform.position, ring);
        }
    }
}